import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleBannerAction = createAsyncThunk(
    'get-single-banner',
    async (data = null, { rejectWithValue }) => {
        try {
            console.log("data-->",data);
            const res = await axios.get(`/admins/api//get-single-banner/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleBannerSlice = createSlice({
    name: 'get-single-banner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleBannerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleBannerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleBannerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleBannerReducer = getSingleBannerSlice.reducer    